import React from 'react';
import styled from 'styled-components';
import Top_Menu from '../main/Top_Menu';
import Bottom_Menu from '../main/Bottom_Menu';
import lang from '../language/Eng_eng.json';

const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  padding-top: 100px;
  background-color: #F3EFE6;
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  flex: 1;
  display: flex;
  padding: 80px 5%;
  align-items: center;
  gap: 5%;

  @media (max-width: 1024px) {
    flex-direction: column-reverse;
    padding: 60px 20px;
    gap: 40px;
  }
`;

const TextSide = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0 5%;

  @media (max-width: 1024px) {
    align-items: center;
    text-align: center;
    padding: 0;
  }
`;

const Title = styled.h1`
  font-family: 'EB Garamond', serif;
  font-size: 2.5rem;
  font-weight: 500;
  color: #5C4033;
  margin-bottom: 2rem;
  letter-spacing: 0.12rem;
`;

const Paragraph = styled.p`
  font-size: 1.05rem;
  line-height: 1.8;
  color: #5C4033;
  margin-bottom: 0;
  opacity: 0.85;
  max-width: 600px;
`;

const ImageSide = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 90%;
    height: auto;
    box-shadow: 0 10px 30px rgba(0,0,0,0.1);
  }
`;

const ChefContent = styled(Content)`
  padding-top: 40px;
  
  @media (max-width: 1024px) {
    flex-direction: column;
  }
`;

const FoundersContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 80px 5% 120px;
  background-color: #F3EFE6;
  text-align: center;
  
  img {
    width: 75%;
    max-width: 900px;
    height: auto;
    box-shadow: 0 10px 30px rgba(0,0,0,0.1);
    margin-bottom: 60px;
  }

  .text-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 800px;
  }
`;

const About: React.FC = () => {
  return (
    <Container>
      <Top_Menu />
      <Content>
        <TextSide>
          <Title>{lang.aboutPage.title}</Title>
          {lang.aboutPage.paragraphs.map((p, index) => (
            <Paragraph key={index}>{p}</Paragraph>
          ))}
        </TextSide>
        <ImageSide>
          <img src="/image/Trent-van-der-Jagt-4058-2048x1366.jpg" alt="About Allta" />
        </ImageSide>
      </Content>
      
      <ChefContent>
        <ImageSide>
          <img src="/image/0O2A6537-scaled-e1720656256553-1024x992.jpg" alt="Chef Jung-Su Chang" />
        </ImageSide>
        <TextSide>
          <Title>{lang.aboutPage.chef.title}</Title>
          {lang.aboutPage.chef.paragraphs.map((p, index) => (
            <Paragraph key={index}>{p}</Paragraph>
          ))}
        </TextSide>
      </ChefContent>

      <FoundersContent>
        <img src="/image/about-us-1024x459.png" alt="Founders of Allta" />
        <Title>{lang.aboutPage.founders.title}</Title>
        <div className="text-container">
          {lang.aboutPage.founders.paragraphs.map((p, index) => (
            <Paragraph key={index}>{p}</Paragraph>
          ))}
        </div>
      </FoundersContent>

      <Bottom_Menu />
    </Container>
  );
};

export default About;
